import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
import { Converter, Occ, Product } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class CustomProductNameNormalizer implements Converter<Occ.Product, Product> {
  constructor(private route: ActivatedRoute, private router: Router) {}

  convert(source: Occ.Product, target: Product): Product {
    if (source.name && (source as any).normalizedName) {
      (target as any).nameForUrl = (source as any).normalizedName;
    }
    return target as Product;
  }
}
